/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostMemoryVoiceSignedurl200Response
 */
export interface PostMemoryVoiceSignedurl200Response {
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurl200Response
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurl200Response
     */
    filePath?: string;
    /**
     * 
     * @type {string}
     * @memberof PostMemoryVoiceSignedurl200Response
     */
    signedUrl?: string;
    /**
     * 
     * @type {object}
     * @memberof PostMemoryVoiceSignedurl200Response
     */
    fields?: object;
    /**
     * 
     * @type {boolean}
     * @memberof PostMemoryVoiceSignedurl200Response
     */
    otpVerifyResult: boolean;
}

/**
 * Check if a given object implements the PostMemoryVoiceSignedurl200Response interface.
 */
export function instanceOfPostMemoryVoiceSignedurl200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "otpVerifyResult" in value;

    return isInstance;
}

export function PostMemoryVoiceSignedurl200ResponseFromJSON(json: any): PostMemoryVoiceSignedurl200Response {
    return PostMemoryVoiceSignedurl200ResponseFromJSONTyped(json, false);
}

export function PostMemoryVoiceSignedurl200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostMemoryVoiceSignedurl200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
        'signedUrl': !exists(json, 'signedUrl') ? undefined : json['signedUrl'],
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
        'otpVerifyResult': json['otpVerifyResult'],
    };
}

export function PostMemoryVoiceSignedurl200ResponseToJSON(value?: PostMemoryVoiceSignedurl200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'filePath': value.filePath,
        'signedUrl': value.signedUrl,
        'fields': value.fields,
        'otpVerifyResult': value.otpVerifyResult,
    };
}

